'use strict';

function trim(str) {
  return str.trim();
}

module.exports = trim;